export const TITLE = "E- Trio Touro Max Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for E- Trio Touro Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "E- Trio Touro Max, Etrio Touro Max, Etrio electric vehicle, Etrio electric cargo vehicle, Etrio electric commercial vehicle, Etrio Touro Max price, Etrio Touro Max specifications, Etrio Touro Max range, Etrio Touro Max load capacity, Etrio electric vehicle price, Etrio commercial vehicle, Etrio electric auto, Etrio EV, Etrio electric truck, Etrio cargo vehicle, Etrio electric vehicle specifications, Etrio electric vehicle features, Etrio electric vehicle reviews, Etrio electric vehicle dealer, Etrio Touro Max++",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio/Touro-MAX",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio/Touro-MAX",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "E- Trio Touro Max Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for E- Trio Touro Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for E- Trio Touro Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "E- Trio Touro Max Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio/Touro-MAX",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Etrio/Touro-MAX";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const HIGHLIGHTS_DESCRIPTION = "Etrio Touro Max ++ electric auto is the ultimate solution for your cargo transportation needs. This powerful three-wheeler electric tempo offers unparalleled performance, stability, and a massive load-carrying capacity of 550 kg, making it the ideal choice for your business. With a torque of 63 Nm, 9.5 kW power, and a top speed of 50 km/hour, it ensures efficient and quick deliveries.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING = "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Etrio Touro Max++";

export const BRAND_DEALER_HEADING = "Etrio Touro Max ++ Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION = "As Etrio's influence continues to expand throughout India, With a growing community of individuals and businesses turning to Etrio for their transportation needs, renowned for its commitment to affordability without compromising on quality, Turno is delighted to introduce the remarkable Etrio Tour Max ++ electric auto.";

export const FAQ_HEADING_TEXT = "FAQs on Etrio Touro Max ++";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Etrio", href: "/electric-commercial-vehicles/Etrio" },
  { label: "Touro Max" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Etrio",
      item: "https://www.turno.club/electric-commercial-vehicles/Etrio",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Touro Max",
      item: VEHICLE_LINK,
    },
  ],
};